export default "__VITE_ASSET__O$LzOo48__"